import Feedback from "../components/Help/Feedback/Feedback";
function FeedbackPage() {
    return (
            <Feedback />
    )
}
export default FeedbackPage;